// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-calendar {
  width: 328px;
  border: none;
  background-color: white;
}
.react-calendar__navigation {
  display: flex;
  height: 36px;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  padding: 6px 8px;
  margin-bottom: 0px;
  --tw-bg-opacity: 1;
  background-color: rgb(246 246 246 / var(--tw-bg-opacity, 1));
  border-radius: 8px;
}
.react-calendar__navigation__label {
  cursor: pointer;
}
.react-calendar__navigation__label__labelText {
  font-size: 14px;
  --tw-text-opacity: 1;
  color: rgb(65 70 81 / var(--tw-text-opacity, 1));
}
.react-calendar__navigation__arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  min-width: unset !important;
  padding: 0;
  border-radius: 6px;
  background-color: white !important;
  border: 1px solid;
  cursor: pointer;
  --tw-border-opacity: 1;
  border-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
}
.react-calendar__navigation__arrow:enabled:hover {
  background-color: var(--color-primary-50, #F0F9FF);
}
.react-calendar__navigation__arrow:enabled:focus {
  background-color: var(--color-primary-100, #E0F2FE);
}
.react-calendar__viewContainer {
  padding-top: 8px;
}
.react-calendar__tile {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px !important;
  padding: 0;
  cursor: pointer;
}
.react-calendar__tile abbr,
.react-calendar__tile span {
  font-size: 14px;
  --tw-text-opacity: 1;
  color: rgb(65 70 81 / var(--tw-text-opacity, 1));
}
.react-calendar__tile:not(.react-calendar__tile--active):enabled:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(246 246 246 / var(--tw-bg-opacity, 1));
}
.react-calendar__tile--now {
  border: 1px solid;
  border-color: var(--color-primary-400, #36BFFA);
}
.react-calendar__tile--now:hover {
  background-color: var(--color-primary-50, #F0F9FF) !important;
}
.react-calendar__tile--range, .react-calendar__tile--hover {
  border: none;
}
.react-calendar__tile--range abbr, .react-calendar__tile--hover abbr {
  color: var(--color-primary-500, #0BA5EC) !important;
}
.react-calendar__tile--range--now .react-calendar__tile--range, .react-calendar__tile--range--now .react-calendar__tile--hover, .react-calendar__tile--hover--now .react-calendar__tile--range, .react-calendar__tile--hover--now .react-calendar__tile--hover {
  background-color: transparent !important;
}

.react-calendar__tile--rangeStart, .react-calendar__tile--rangeEnd, .react-calendar__tile--hoverStart, .react-calendar__tile--hoverEnd {
  position: relative;
  z-index: 3;
  background-color: var(--color-primary-500, #0BA5EC);
}
.react-calendar__tile--rangeStart:hover, .react-calendar__tile--rangeEnd:hover, .react-calendar__tile--hoverStart:hover, .react-calendar__tile--hoverEnd:hover {
  background-color: var(--color-primary-500, #0BA5EC) !important;
}
.react-calendar__tile--rangeStart abbr, .react-calendar__tile--rangeEnd abbr, .react-calendar__tile--hoverStart abbr, .react-calendar__tile--hoverEnd abbr {
  color: white !important;
}
.react-calendar__tile--range:not(.react-calendar__tile--rangeStart):not(.react-calendar__tile--rangeEnd), .react-calendar__tile--hover:not(.react-calendar__tile--hoverStart):not(.react-calendar__tile--hoverEnd) {
  position: relative;
  overflow: visible !important;
  z-index: 2;
}
.react-calendar__tile--range:not(.react-calendar__tile--rangeStart):not(.react-calendar__tile--rangeEnd):before, .react-calendar__tile--hover:not(.react-calendar__tile--hoverStart):not(.react-calendar__tile--hoverEnd):before {
  content: "";
  position: absolute;
  left: -16px;
  width: calc(100% + 32px);
  height: 100%;
  background-color: var(--color-primary-50, #F0F9FF);
}
.react-calendar__tile--range:not(.react-calendar__tile--rangeStart):not(.react-calendar__tile--rangeEnd) abbr, .react-calendar__tile--hover:not(.react-calendar__tile--hoverStart):not(.react-calendar__tile--hoverEnd) abbr {
  z-index: 2;
}
.react-calendar__tile:nth-child(7n):before {
  width: calc(100% + 16px) !important;
  border-radius: 8px;
}
.react-calendar__tile:nth-child(7n+1):before {
  left: 0 !important;
  border-radius: 8px;
}
.react-calendar__month-view__weekdays {
  display: grid !important;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
  padding-bottom: 8px;
}
.react-calendar__month-view__weekdays__weekday {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
}
.react-calendar__month-view__weekdays__weekday abbr {
  font-size: 14px;
  text-decoration: none;
  text-transform: uppercase;
  --tw-text-opacity: 1;
  color: rgb(113 118 128 / var(--tw-text-opacity, 1));
}
.react-calendar__month-view__days {
  display: grid !important;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
}
.react-calendar__month-view__days__day {
  height: 40px;
}
.react-calendar__month-view__days__day:disabled abbr, .react-calendar__month-view__days__day--neighboringMonth abbr {
  --tw-text-opacity: 1;
  color: rgb(213 215 218 / var(--tw-text-opacity, 1));
}
.react-calendar__month-view__weekNumbers {
  position: relative;
  gap: 8px;
  padding-top: 48px;
  margin-right: 4px;
  border-right: 1px solid;
  --tw-border-opacity: 1;
  border-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
  color: var(--color-primary-500, #0BA5EC);
}
.react-calendar__month-view__weekNumbers .react-calendar__tile {
  height: 40px;
  flex: unset !important;
  cursor: default;
}
.react-calendar__month-view__weekNumbers .react-calendar__tile:hover {
  background-color: transparent !important;
}
.react-calendar__month-view__weekNumbers .react-calendar__tile span {
  color: var(--color-primary-500, #0BA5EC);
}
.is-week .react-calendar__month-view__weekNumbers .react-calendar__tile {
  cursor: pointer;
}

.react-calendar__month-view__weekNumbers:before {
  content: "W";
  position: absolute;
  top: 11px;
  left: 13px;
  width: 100%;
  font-size: 14px;
  --tw-text-opacity: 1;
  color: rgb(113 118 128 / var(--tw-text-opacity, 1));
}
.react-calendar__month-view > :first-child {
  align-items: unset !important;
}
.react-calendar__year-view__months, .react-calendar__year-view__years, .react-calendar__year-view__decades, .react-calendar__decade-view__months, .react-calendar__decade-view__years, .react-calendar__decade-view__decades, .react-calendar__century-view__months, .react-calendar__century-view__years, .react-calendar__century-view__decades {
  display: grid !important;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.react-calendar__year-view__months__month, .react-calendar__year-view__months__decade, .react-calendar__year-view__months__century, .react-calendar__year-view__months__year, .react-calendar__year-view__years__month, .react-calendar__year-view__years__decade, .react-calendar__year-view__years__century, .react-calendar__year-view__years__year, .react-calendar__year-view__decades__month, .react-calendar__year-view__decades__decade, .react-calendar__year-view__decades__century, .react-calendar__year-view__decades__year, .react-calendar__decade-view__months__month, .react-calendar__decade-view__months__decade, .react-calendar__decade-view__months__century, .react-calendar__decade-view__months__year, .react-calendar__decade-view__years__month, .react-calendar__decade-view__years__decade, .react-calendar__decade-view__years__century, .react-calendar__decade-view__years__year, .react-calendar__decade-view__decades__month, .react-calendar__decade-view__decades__decade, .react-calendar__decade-view__decades__century, .react-calendar__decade-view__decades__year, .react-calendar__century-view__months__month, .react-calendar__century-view__months__decade, .react-calendar__century-view__months__century, .react-calendar__century-view__months__year, .react-calendar__century-view__years__month, .react-calendar__century-view__years__decade, .react-calendar__century-view__years__century, .react-calendar__century-view__years__year, .react-calendar__century-view__decades__month, .react-calendar__century-view__decades__decade, .react-calendar__century-view__decades__century, .react-calendar__century-view__decades__year {
  height: 64px;
  white-space: nowrap;
}
.is-compact .react-calendar__year-view__months__month, .is-compact .react-calendar__year-view__months__decade, .is-compact .react-calendar__year-view__months__century, .is-compact .react-calendar__year-view__months__year, .is-compact .react-calendar__year-view__years__month, .is-compact .react-calendar__year-view__years__decade, .is-compact .react-calendar__year-view__years__century, .is-compact .react-calendar__year-view__years__year, .is-compact .react-calendar__year-view__decades__month, .is-compact .react-calendar__year-view__decades__decade, .is-compact .react-calendar__year-view__decades__century, .is-compact .react-calendar__year-view__decades__year, .is-compact .react-calendar__decade-view__months__month, .is-compact .react-calendar__decade-view__months__decade, .is-compact .react-calendar__decade-view__months__century, .is-compact .react-calendar__decade-view__months__year, .is-compact .react-calendar__decade-view__years__month, .is-compact .react-calendar__decade-view__years__decade, .is-compact .react-calendar__decade-view__years__century, .is-compact .react-calendar__decade-view__years__year, .is-compact .react-calendar__decade-view__decades__month, .is-compact .react-calendar__decade-view__decades__decade, .is-compact .react-calendar__decade-view__decades__century, .is-compact .react-calendar__decade-view__decades__year, .is-compact .react-calendar__century-view__months__month, .is-compact .react-calendar__century-view__months__decade, .is-compact .react-calendar__century-view__months__century, .is-compact .react-calendar__century-view__months__year, .is-compact .react-calendar__century-view__years__month, .is-compact .react-calendar__century-view__years__decade, .is-compact .react-calendar__century-view__years__century, .is-compact .react-calendar__century-view__years__year, .is-compact .react-calendar__century-view__decades__month, .is-compact .react-calendar__century-view__decades__decade, .is-compact .react-calendar__century-view__decades__century, .is-compact .react-calendar__century-view__decades__year {
  height: 46px;
}

.react-calendar.is-border {
  width: 368px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  border: 1px solid;
  --tw-border-opacity: 1;
  border-color: rgb(233 234 235 / var(--tw-border-opacity, 1));
  border-radius: 16px;
  box-shadow: 0px 0px 20px 0px rgba(55, 65, 69, 0.08) !important;
}
.react-calendar.is-border.is-compact {
  width: 252px;
  padding: 12px;
}
.react-calendar.is-compact {
  width: 220px;
}
.react-calendar.is-compact .react-calendar__navigation {
  height: 32px;
  padding: 4px;
}
.react-calendar.is-compact .react-calendar__navigation__label__labelText {
  font-size: 12px;
}
.react-calendar.is-compact .react-calendar__tile {
  border-radius: 6px;
  font-size: 12px;
}
.react-calendar.is-compact .react-calendar__tile abbr,
.react-calendar.is-compact .react-calendar__tile span {
  font-size: 12px;
}
.react-calendar.is-compact .react-calendar__tile--range:not(.react-calendar.is-compact .react-calendar__tile--rangeStart):not(.react-calendar.is-compact .react-calendar__tile--rangeEnd):before, .react-calendar.is-compact .react-calendar__tile--hover:not(.react-calendar.is-compact .react-calendar__tile--hoverStart):not(.react-calendar.is-compact .react-calendar__tile--hoverEnd):before {
  left: -9px;
  width: calc(100% + 20px);
}
.react-calendar.is-compact .react-calendar__tile:nth-child(7n):before {
  width: calc(100% + 9px) !important;
  border-radius: 0 6px 6px 0;
}
.react-calendar.is-compact .react-calendar__tile:nth-child(7n+1):before {
  border-radius: 6px;
}
.react-calendar.is-compact .react-calendar__month-view__weekdays {
  gap: 4px;
}
.react-calendar.is-compact .react-calendar__month-view__weekdays__weekday {
  height: 28px;
}
.react-calendar.is-compact .react-calendar__month-view__weekdays__weekday abbr {
  font-size: 12px;
}
.react-calendar.is-compact .react-calendar__month-view__days {
  gap: 8px 4px;
}
.react-calendar.is-compact .react-calendar__month-view__days__day {
  height: 28px;
}
.react-calendar.is-compact .react-calendar__month-view__weekNumbers {
  padding-top: 36px;
}
.react-calendar.is-compact .react-calendar__month-view__weekNumbers .react-calendar__tile {
  height: 28px;
  flex-shrink: 0 !important;
}
.react-calendar.is-compact .react-calendar__month-view__weekNumbers:before {
  top: 7px;
  left: 7px;
  font-size: 12px;
}
.react-calendar.is-compact .react-calendar__year-view__months__month abbr {
  font-size: 10px;
}
.react-calendar.is-compact .react-calendar__century-view__decades__decade {
  font-size: 10px;
}
.react-calendar.is-week .react-calendar__tile--range {
  background-color: var(--color-primary-50, #F0F9FF);
}
.react-calendar.is-week .react-calendar__tile--range abbr {
  color: var(--color-primary-500, #0BA5EC) !important;
}
.react-calendar.is-week .react-calendar__tile--range:hover {
  background-color: var(--color-primary-50, #F0F9FF) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/shared/Calendar/lib/Calendar.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,YAAA;EACA,uBAAA;AADF;AAIE;EACE,aAAA;EACA,YAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EAAA,4DAAA;EACA,kBAAA;AAFJ;AAII;EACE,eAAA;AAFN;AAGM;EACE,eAAA;EACA,oBAAA;EAAA,gDAAA;AADR;AAKI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,UAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;EAAA,4DAAA;AAHN;AAKQ;EAAA;AAAA;AAGA;EAAA;AAAA;AAKN;EACE,gBAAA;AALJ;AAQE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,UAAA;EACA,eAAA;AANJ;AAOI;;EAEE,eAAA;EACA,oBAAA;EAAA,gDAAA;AALN;AASQ;EAAA,kBAAA;EAAA;AAAA;AAGJ;EACE,iBAAA;EACA,+CAAA;AAPN;AASQ;EAAA;AAAA;AAIJ;EAEE,YAAA;AATN;AAWQ;EAAA;AAAA;AAEO;EACP,wCAAA;AARR;;AAYI;EAIE,kBAAA;EACA,UAAA;EACA,mDAAA;AAZN;AAcQ;EAAA;AAAA;AAEF;EACE,uBAAA;AAXR;AAeI;EAEE,kBAAA;EACA,4BAAA;EACA,UAAA;AAdN;AAeM;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,wBAAA;EACA,YAAA;EACA,kDAAA;AAbR;AAeM;EACE,UAAA;AAbR;AAiBM;EACE,mCAAA;EACA,kBAAA;AAfR;AAmBM;EACE,kBAAA;EACA,kBAAA;AAjBR;AAuBI;EACE,wBAAA;EACA,qCAAA;EACA,QAAA;EACA,mBAAA;AArBN;AAsBM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YA3IO;AAuHf;AAqBQ;EACE,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EAAA,mDAAA;AAnBV;AAuBI;EACE,wBAAA;EACA,qCAAA;EACA,QAAA;AArBN;AAsBM;EACE,YAzJO;AAqIf;AAwBY;EAAA,oBAAA;EAAA;AAAA;AAKR;EACE,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;EACA,sBAAA;EAAA,4DAAA;EACA,wCAAA;AAxBN;AA0BM;EACE,YA5KO;EA6KP,sBAAA;EACA,eAAA;AAxBR;AAyBQ;EACE,wCAAA;AAvBV;AA0BU;EAAA;AAAA;AAEO;EACP,eAAA;AAvBV;;AA2BM;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;EAAA,mDAAA;AAxBR;AA2BI;EACE,6BAAA;AAzBN;AAgCI;EAGE,wBAAA;EACA,qCAAA;EACA,QAAA;AAhCN;AAiCM;EAIE,YAAA;EACA,mBAAA;AAlCR;AAqCQ;EAIE,YAAA;AAtCV;;AA4CE;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,sBAAA;EAAA,4DAAA;EACA,mBAAA;EACA,8DAAA;AAzCJ;AA0CI;EACE,YAAA;EACA,aAAA;AAxCN;AA4CE;EAGE,YAAA;AA5CJ;AA+CM;EACE,YAAA;EACA,YAAA;AA7CR;AA8CQ;EACE,eATK;AAnCf;AA+CM;EACE,kBAAA;EACA,eAdO;AA/Bf;AA8CQ;;EAEE,eAjBK;AA3Bf;AAgDU;EACE,UAAA;EACA,wBAAA;AA9CZ;AAkDU;EACE,kCAAA;EACA,0BAAA;AAhDZ;AAoDU;EACE,kBAAA;AAlDZ;AAuDQ;EACE,QAAA;AArDV;AAsDU;EACE,YAzCK;AAXjB;AAqDY;EACE,eA5CC;AAPf;AAuDQ;EACE,YAAA;AArDV;AAsDU;EACE,YAlDK;AAFjB;AAuDQ;EACE,iBAAA;AArDV;AAsDU;EACE,YAxDK;EAyDL,yBAAA;AApDZ;AAsDU;EACE,QAAA;EACA,SAAA;EACA,eAAA;AApDZ;AAyDQ;EACE,eAAA;AAvDV;AA0DM;EACE,eAAA;AAxDR;AAgEQ;EAAA;AAAA;AAEE;EAAA;AAAA;AAGA;EAAA;AAAA","sourcesContent":["@use '../../../../styles/lib' as lib;\n\n.react-calendar {\n  width: 328px;\n  border: none;\n  background-color: white;\n  $tileHeight: 40px;\n\n  &__navigation {\n    display: flex;\n    height: 36px;\n    justify-content: space-between;\n    align-items: center;\n    gap: 4px;\n    padding: 6px 8px;\n    margin-bottom: 0px;\n    @apply bg-neutral-75;\n    border-radius: 8px;\n\n    &__label {\n      cursor: pointer;\n      &__labelText {\n        font-size: 14px;\n        @apply text-neutral-700;\n      }\n    }\n\n    &__arrow {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 24px;\n      height: 24px;\n      min-width: unset !important;\n      padding: 0;\n      border-radius: 6px;\n      background-color: white !important;\n      border: 1px solid;\n      cursor: pointer;\n      @apply border-neutral-200;\n      &:enabled:hover {\n        @apply bg-primary-50;\n      }\n      &:enabled:focus {\n        @apply bg-primary-100;\n      }\n    }\n  }\n\n  &__viewContainer {\n    padding-top: 8px;\n  }\n\n  &__tile {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 8px !important;\n    padding: 0;\n    cursor: pointer;\n    abbr,\n    span {\n      font-size: 14px;\n      @apply text-neutral-700;\n    }\n    &:not(&--active) {\n      &:enabled:hover {\n        @apply bg-neutral-75;\n      }\n    }\n    &--now {\n      border: 1px solid;\n      @apply border-primary-400;\n      &:hover {\n        @apply bg-primary-50 !important;\n      }\n    }\n\n    &--range,\n    &--hover {\n      border: none;\n      abbr {\n        @apply text-primary-500 !important;\n      }\n      @at-root &--now & {\n        background-color: transparent !important;\n      }\n    }\n\n    &--rangeStart,\n    &--rangeEnd,\n    &--hoverStart,\n    &--hoverEnd {\n      position: relative;\n      z-index: 3;\n      @apply bg-primary-500;\n      &:hover {\n        @apply bg-primary-500 !important;\n      }\n      abbr {\n        color: white !important;\n      }\n    }\n\n    &--range:not(&--rangeStart):not(&--rangeEnd),\n    &--hover:not(&--hoverStart):not(&--hoverEnd) {\n      position: relative;\n      overflow: visible !important;\n      z-index: 2;\n      &:before {\n        content: '';\n        position: absolute;\n        left: -16px;\n        width: calc(100% + 32px);\n        height: 100%;\n        @apply bg-primary-50;\n      }\n      abbr {\n        z-index: 2;\n      }\n    }\n    &:nth-child(7n) {\n      &:before {\n        width: calc(100% + 16px) !important;\n        border-radius: 8px;\n      }\n    }\n    &:nth-child(7n + 1) {\n      &:before {\n        left: 0 !important;\n        border-radius: 8px;\n      }\n    }\n  }\n\n  &__month-view {\n    &__weekdays {\n      display: grid !important;\n      grid-template-columns: repeat(7, 1fr);\n      gap: 8px;\n      padding-bottom: 8px;\n      &__weekday {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: $tileHeight;\n        abbr {\n          font-size: 14px;\n          text-decoration: none;\n          text-transform: uppercase;\n          @apply text-neutral-500;\n        }\n      }\n    }\n    &__days {\n      display: grid !important;\n      grid-template-columns: repeat(7, 1fr);\n      gap: 8px;\n      &__day {\n        height: $tileHeight;\n        &:disabled,\n        &--neighboringMonth {\n          abbr {\n            @apply text-neutral-300;\n          }\n        }\n      }\n    }\n    &__weekNumbers {\n      position: relative;\n      gap: 8px;\n      padding-top: 48px;\n      margin-right: 4px;\n      border-right: 1px solid;\n      @apply border-neutral-200;\n      @apply text-primary-500;\n\n      .react-calendar__tile {\n        height: $tileHeight;\n        flex: unset !important;\n        cursor: default;\n        &:hover {\n          background-color: transparent !important;\n        }\n        span {\n          @apply text-primary-500;\n        }\n        @at-root .is-week & {\n          cursor: pointer;\n        }\n      }\n\n      &:before {\n        content: 'W';\n        position: absolute;\n        top: 11px;\n        left: 13px;\n        width: 100%;\n        font-size: 14px;\n        @apply text-neutral-500;\n      }\n    }\n    & > :first-child {\n      align-items: unset !important;\n    }\n  }\n\n  &__year-view,\n  &__decade-view,\n  &__century-view {\n    &__months,\n    &__years,\n    &__decades {\n      display: grid !important;\n      grid-template-columns: repeat(3, 1fr);\n      gap: 8px;\n      &__month,\n      &__decade,\n      &__century,\n      &__year {\n        height: 64px;\n        white-space: nowrap;\n      }\n      @at-root .is-compact & {\n        &__month,\n        &__decade,\n        &__century,\n        &__year {\n          height: 46px;\n        }\n      }\n    }\n  }\n\n  &.is-border {\n    width: 368px;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    border: 1px solid;\n    @apply border-neutral-200;\n    border-radius: 16px;\n    box-shadow: 0px 0px 20px 0px rgba(55, 65, 69, 0.08) !important;\n    &.is-compact {\n      width: 252px;\n      padding: 12px;\n    }\n  }\n\n  &.is-compact {\n    $fontSize: 12px;\n    $tileHeight: 28px;\n    width: 220px;\n\n    .react-calendar {\n      &__navigation {\n        height: 32px;\n        padding: 4px;\n        &__label__labelText {\n          font-size: $fontSize;\n        }\n      }\n      &__tile {\n        border-radius: 6px;\n        font-size: $fontSize;\n        abbr,\n        span {\n          font-size: $fontSize;\n        }\n        &--range:not(&--rangeStart):not(&--rangeEnd),\n        &--hover:not(&--hoverStart):not(&--hoverEnd) {\n          &:before {\n            left: -9px;\n            width: calc(100% + 20px);\n          }\n        }\n        &:nth-child(7n) {\n          &:before {\n            width: calc(100% + 9px) !important;\n            border-radius: 0 6px 6px 0;\n          }\n        }\n        &:nth-child(7n + 1) {\n          &:before {\n            border-radius: 6px;\n          }\n        }\n      }\n      &__month-view {\n        &__weekdays {\n          gap: 4px;\n          &__weekday {\n            height: $tileHeight;\n            abbr {\n              font-size: $fontSize;\n            }\n          }\n        }\n        &__days {\n          gap: 8px 4px;\n          &__day {\n            height: $tileHeight;\n          }\n        }\n        &__weekNumbers {\n          padding-top: 36px;\n          .react-calendar__tile {\n            height: $tileHeight;\n            flex-shrink: 0 !important;\n          }\n          &:before {\n            top: 7px;\n            left: 7px;\n            font-size: 12px;\n          }\n        }\n      }\n      &__year-view__months__month {\n        abbr {\n          font-size: 10px;\n        }\n      }\n      &__century-view__decades__decade {\n        font-size: 10px;\n      }\n    }\n  }\n\n  &.is-week {\n    .react-calendar__tile {\n      &--range {\n        @apply bg-primary-50;\n        abbr {\n          @apply text-primary-500 !important;\n        }\n        &:hover {\n          @apply bg-primary-50 !important;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
